import React from 'react';
import { Text } from 'rebass';
import { position } from 'styled-system';
import { styled, Media, Colors } from '../../../themes';
import { css } from 'styled-components';
import { device } from 'themes/media-queries';

interface Props {
  active: boolean;
  onPress: () => void;
}

const HamburgerButton = (props: Props) => {
  const { active, onPress } = props;
  return (
    <Button onClick={onPress} isActive={active}>
      <Hamburger>
        <HamburgerLine isActive={active} />
      </Hamburger>
      <ButtonText fontSize={1} fontWeight={700} isActive={active}>
        {'Menu'}
      </ButtonText>
    </Button>
  );
};

const activeButtonStyles = `
  right: 100%;
  background-color: black;

  ${Media.tablet} {
    right: 400px;
  }
`;

const Button = styled.button`
  position: absolute;
  top: 7.5rem;
  right: 15rem;
  pointer-events: all;
  width: 8rem;
  height: 8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  box-shadow: 0 10px 33px 0 rgba(43, 44, 61, 0.15);
  transition: all ease-out 0.4s;
  outline: none;
  border: none;
  background: ${Colors.white};
  z-index: 10;

  @media ${device.laptop} {
    top: 7.5rem;
    right: 6rem;
  }

  @media ${device.mobileL} {
    top: 3rem;
    right: 3rem;
    width: 6rem;
    height: 6rem;
  }

  ${({ isActive }) =>
    isActive
      ? css`
          ${activeButtonStyles}
        `
      : ''}
`;

const ButtonText = styled(Text)`
  display: none;
  position: relative;
  top: 0;
  color: ${({ theme }) => theme.colors.darkOrange};
  user-select: none;
  transition: all ease-out 0.4s;

  ${Media.tablet} {
    display: ${({ isActive }) => (isActive ? 'none' : 'block')};
  }
`;

const Hamburger = styled.div`
  z-index: 1;
  width: 20px;
  height: 20px;

  border-radius: 0 3px 3px 0;
  cursor: pointer;
  transition: box-shadow 0.6s ease;
  backface-visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  ${Media.tablet} {
    width: 30px;
    height: 30px;
  }
`;

interface HamburgerLine {
  isActive?: boolean;
}

const HamburgerLine = styled.div<HamburgerLine>`
  position: relative;
  flex: none;
  width: 100%;
  height: 3px;
  background: ${({ isActive, theme }) =>
    isActive ? 'white' : theme.colors.darkOrange};
  transition: transform 0.6s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(${props => (props.isActive ? '-225deg' : 0)});

  :before,
  :after {
    content: '';
    position: absolute;
    z-index: 1;
    top: ${({ isActive }) => (isActive ? 0 : '-5px')};
    left: 0;
    width: 100%;
    height: 3px;
    background: inherit;
    transition: transform 0.4s ease;
    transform: rotate(${({ isActive }) => (isActive ? '-90deg' : 0)});

    ${Media.tablet} {
      top: ${({ isActive }) => (isActive ? 0 : '-8px')};
    }
  }

  :after {
    top: 5px;
    opacity: ${({ isActive }) => (isActive ? 0 : 1)};

    ${Media.tablet} {
      top: 8px;
    }
  }
`;

export default HamburgerButton;
